import { handleError } from '@offerzen/pinata-shame'
import { notify } from '@offerzen/react-utils'

export const errorHandler = (error, defaultErrorMessage) =>
  handleError({ errorClientCallback: () => notify(error), error, defaultErrorMessage })
